<template>
    <div>
        <vue-element-loading :active="show" spinner="ring" color="#006db3" size="128" text="กรุณารอสักครู่..." is-full-screen/>
        <NavBar :title="'สร้างฟอร์ม'"></NavBar>
        <div :class="'container '+(validated ? 'was-validated':'')">
            <div class="card mb-0 border-header" style="cursor: pointer;" @click="cardActive(null)">
                <div v-if="active" :class="'card-body '+(active ? ' border-active':'')">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 input-group-lg">
                            <label class="m-0"><b>ชื่อแบบฟอร์ม<span class="text-danger">*</span></b></label>
                            <input type="text" :class="'form-control '+(validated ? 'was-validated':'')" v-model="name" @focus="onFocus" placeholder="ชื่อแบบฟอร์ม" required>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12 input-group-sm mt-2">
                            <textarea type="text" class="form-control textarea-description pb-0" v-model="description" @focus="onFocus" placeholder="คำอธิบายแบบฟอร์ม"></textarea>
                        </div>
                    </div>
                </div>
                <div v-else class="card-body">
                    <div class="row">
                        <div class="col-xl-12 col-lg-12 col-md-12 input-group-lg">
                            <h2 v-html="name" class="m-0"></h2>
                        </div>
                        <div class="col-xl-12 col-lg-12 col-md-12">
                            <small v-html="description"></small>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-3 p-2 div-footer" style="background: #f7f7f7;">
                <div class="row">
                    <div class="col-xl-12 col-lg-12 col-md-12">
                        <button type="button" class="btn btn-light pull-left" @click="formPreview"><i class="fa fa-eye fa-lg text-danger" aria-hidden="true"></i> แสดงตัวอย่าง</button>
                        <button type="button" class="btn btn-light pull-left ml-2" @click="validatedForm"><i class="fa fa-floppy-o fa-lg text-success" aria-hidden="true"></i> บันทึกแบบฟอร์ม</button>
                        <button type="button" class="btn btn-light pull-right" @click="addQuestion"><i class="fa fa-plus-circle fa-lg text-primary" aria-hidden="true"></i> เพิ่มคำถาม</button>
                    </div>
                </div>
            </div>

            <!-- <form class="was-validated"> -->
            <draggable tag="ul" :list="listQuestion" class="list-group" handle=".handle"  @choose="choose" @unchoose="unchoose">
                <div v-for="(itQ, idQ) in listQuestion" :key="idQ" :class="'card mb-3 '+(itQ.active ? ' border-active':'')">
                    <div class="text-center handle" :style="'cursor:'+(cursor ? 'grabbing':'grab')" ><span>:::</span></div>
                    <div v-if="itQ.active" class="card-body pt-0 pb-3">
                        <div class="row">
                            <div class="col-xl-8 col-lg-8 col-md-8 ">
                                <label class="m-0"><b>คำถาม<span class="text-danger">*</span></b></label>
                                <textarea type="text" :class="'form-control '+(validated ? 'was-validated':'')" v-model="itQ.name" @focus="onFocus" placeholder="คำถาม" required></textarea>
                                <div class="invalid-feedback m-0">กรุณากรอกคำถาม</div>
                            </div>

                            <div class="col-xl-4 col-lg-4 col-md-4">
                                <label class="m-0"><b>ประเภทตัวเลือก<span class="text-danger">*</span></b></label>
                                <v-select v-model="itQ.type" :options="listOption" label="title" :clearable="false" :searchable="false" :value="listOption">
                                    <template #selected-option="{ title, icon }">
                                        <div style="align-items: baseline;">
                                            <span class="fa" :class="'pl-2 pr-1 iconxx '+icon"></span> {{ title }}
                                        </div>
                                    </template>
                                    <template slot="option" slot-scope="option">
                                        <div style="padding: 10px;">
                                            <span class="iconxx fa" :class="option.icon"></span> {{ option.title }}
                                        </div>
                                    </template>
                                </v-select>
                            </div>

                            <div class="col-xl-12 col-lg-12 col-md-12 input-group input-group-sm mt-2">
                                <textarea type="text" class="form-control textarea-description pb-0" v-model="itQ.description" @focus="onFocus" placeholder="คำอธิบาย"></textarea>
                            </div>
                        </div>

                        <div class="row mt-3">
                            <div class="col-xl-11 col-lg-11 col-md-11">
                                <label class="m-0 pl-5"><b>ตัวเลือก<span class="text-danger">*</span></b></label>
                                <draggable tag="ul" :list="itQ.listChoice" class="list-group" handle=".handle" @choose="choose" @unchoose="unchoose">
                                    <div v-for="(itC, idC) in itQ.listChoice" :key="idC" class="row pt-0 pb-3">
                                        <span class="text-black-50 handle" :style="'font-size: 25px; cursor:'+(cursor ? 'grabbing':'grab')">::</span>
                                        <div class="col-xl-auto col-lg-auto col-md-auto mt-2">
                                            <i :class="'fa '+(itQ.type.icon)+' fa-lg text-black-50'" aria-hidden="true"></i>
                                        </div>
                                        <div class="col-xl-10 col-lg-10 col-md-10 pl-0 input-group">
                                            <input type="text" :class="'form-control '+(!validated || itC.class!='' ? itC.class:'was-validated')" v-model="itC.name" @focus="onFocus" @keyup="checkChoiceName(idQ)" required>
                                            <div :class="'invalid-feedback m-0'" v-html="!validated || itC.class!='' ? 'ข้อมูลตัวเลือกซ้ำ กรุณาแก้ไขข้อมูล':'กรุณากรอกตัวเลือก'"></div>
                                        </div>
                                        <div class="col-xl-auto col-lg-auto col-md-auto mt-2">
                                            <i class="fa fa-times close fa-lg" style="cursor: pointer;" @click="removeChoice(idQ,idC)"></i>
                                        </div>
                                    </div>
                                </draggable>

                                <div class="row">
                                    <span class="text-light handle" style="font-size: 25px;">::</span>
                                    <div class="col-xl-auto col-lg-auto col-md-auto mt-2">
                                        <i :class="'fa '+(itQ.type.icon)+' fa-lg text-black-50'" aria-hidden="true"></i>
                                    </div>
                                    <div class="col-xl-10 col-lg-10 col-md-10 pl-0 input-group ">
                                        <button type="button" class="btn btn-light" @click="addChoice(idQ)">เพิ่มตัวเลือก</button>
                                    </div>
                                </div>
                            </div>
                        </div><hr>

                        <div class="row">
                            <div class="col-xl-9 col-lg-8 col-md-8"></div>
                            <div class="col-xl-auto col-lg-auto col-md-auto">
                                <button type="button" class="btn btn-light" title="คัดลอก" @click="copyQuestion(idQ,itQ)"><i class="fa fa-clone fa-lg text-secondary" aria-hidden="true"></i></button>
                            </div>
                            <div class="col-xl-auto col-lg-auto col-md-auto">
                                <button type="button" class="btn btn-light" title="ลบ" @click="removeQuestion(idQ)"><i class="fa fa-trash fa-lg text-danger" aria-hidden="true"></i></button>
                            </div>
                            <div class="vl" style="border-left: 1px solid #ced4da;"></div>
                            <div class="col-xl-auto col-lg-auto col-md-auto">
                                <div class="custom-control custom-switch mt-2">
                                    <input type="checkbox" class="custom-control-input" :id="'request'+idQ" v-model="itQ.request">
                                    <label class="custom-control-label" :for="'request'+idQ">จำเป็น</label>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div v-else class="card-body pt-0" style="cursor: pointer;" @click="cardActive(idQ)">
                        <div class="row">
                            <div class="col-xl-12 col-lg-12 col-md-12">
                                <label class="m-0"><b>{{ itQ.name }}<span v-if="itQ.request" class="text-danger">*</span></b></label>
                            </div>
                            <div class="col-xl-12 col-lg-12 col-md-12 pb-3">
                                <small v-html="itQ.description"></small>
                            </div>
                        </div>
                        <div v-for="(itC, idC) in itQ.listChoice" :key="idC" class="row">
                            <div class="col-xl-auto col-lg-auto col-md-auto">
                                <i :class="'fa '+(itQ.type.icon)+' fa-lg text-black-50'" aria-hidden="true"></i>
                            </div>
                            <div class="col-xl-10 col-lg-10 col-md-10 pl-0 input-group">
                                <p v-html="itC.name"></p>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </draggable>
            <!-- </form> -->
        </div>

    </div>
</template>

<script>
import Vue from 'vue';
import Api from './../api';
import draggable from 'vuedraggable'
import vSelect from 'vue-select'
Vue.component('v-select', vSelect)
import 'vue-select/dist/vue-select.css';
// import "vue-select/src/scss/vue-select.scss";

import NavBar from '@/components/NavBar';

export default {
    components: {
        NavBar,
        draggable
    },
    data(){
        return {
            user: null,
            show: false,
            validated: false,
            name: '',
            description: '',
            active: false,
            cursor: false,
            listQuestion: [],
            listOption: [],

        }
    },

    created(){
        this.user = this.$store.state.user;
        this.getChoiceTypeActiveAll()
        this.setInitiativeCreate();
    },

    watch: {
        // listQuestion:{
        //     handler(val){
        //         console.log(val)
        //         val = val.map((itQ,idQ) => {
        //             return itQ.listChoice.map((itC,idC) => {
        //                 if(itC.name!=""){
        //                     Vue.set(itC, 'name', itC.name)
        //                 }else{
        //                     Vue.set(itC, 'name', 'ตัวเลือก '+(idC+1))
        //                 }
        //             });
        //         });
        //     },
        //     deep: true
        // }
    },

    mounted(){
       
    },

    methods:{
        setInitiativeCreate(){
            this.active = true;
            var obj = this.getObjQuestion();
            this.listQuestion.push(obj);
            var index = (this.listQuestion.length)-1;
            this.checkChoiceName(index);
            this.cardActive(0);
        },

        getObjQuestion(){
            var type = { id: 'radio', title: 'หลายตัวเลือก', icon: 'fa-dot-circle-o', status: '' };
            var choice = this.getObjChoice();
            return { name: "", description: "", request: false, type: type, listChoice: [choice], status: '', class:'', active: false };
        },

        getObjChoice(){
            return { name: "", description: "", status: '', class:'', active: false };
        },

        addQuestion() {
            var obj = this.getObjQuestion();
            this.listQuestion.push(obj);
            var index = (this.listQuestion.length)-1;
            this.checkChoiceName(index);
            this.cardActive(index);
        },

        copyQuestion(indexQuestion,obj){
            var newIndex = indexQuestion+1;
            var copyObj = JSON.parse(JSON.stringify(obj));
            this.listQuestion.splice(newIndex, 0, copyObj);
            this.cardActive(newIndex);
        },

        removeQuestion(indexQuestion) {
            this.listQuestion.splice(indexQuestion, 1);
            if(!this.listQuestion.length){
                this.addQuestion();
            }
        },

        addChoice(indexQuestion) {
            var choice = this.getObjChoice();
            this.listQuestion[indexQuestion].listChoice.push(choice);
            var count = this.listQuestion[indexQuestion].listChoice.length;
            Vue.set(this.listQuestion[indexQuestion].listChoice[count-1], 'name', 'ตัวเลือก '+count)
            this.checkChoiceName(indexQuestion);
        },

        removeChoice(indexQuestion,indexChoice) {
            var obj = this.listQuestion[indexQuestion].listChoice;
            obj.splice(indexChoice, 1);
            if(!obj.length){
                this.addChoice(indexQuestion);
            }else{
                this.checkChoiceName(indexQuestion);
            }
        },

        checkChoiceName(indexQuestion){
            this.listQuestion[indexQuestion].listChoice = this.listQuestion[indexQuestion].listChoice.map((itC,idC) => {
                var findName = this.listQuestion[indexQuestion].listChoice.find((f,i) => f.name==itC.name && idC!=i) 
                if(findName!=undefined){
                    Vue.set(itC, 'class', 'is-invalid')
                }else{
                    Vue.set(itC, 'class', '')
                }
                return itC;
            });
        },

        cardActive(index){
            this.name.trim()=='' ? this.name='ฟอร์มไม่มีชื่อ':'';
            this.active = false;
            this.listQuestion.forEach(itQ => {
                Vue.set(itQ, 'active', false)
                itQ.name.trim()=='' ? itQ.name='คำถามไม่ระบุชื่อ':'';
                itQ.listChoice.forEach((itC,idC) => {
                    itC.name.trim()=='' ? itC.name='ตัวเลือก '+(idC+1):'';
                });
            });

            if(index!=null){
                Vue.set(this.listQuestion[index], 'active', true)
            }else{
                this.active = true;
            }
        },

        formPreview(){
            var data = {
                name: this.name,
                description: this.description,
                listQuestion: JSON.stringify(this.listQuestion)
            };
            let routeData = this.$router.resolve({name: 'preview', query: data});
            window.open(routeData.href, '_blank');
        },

        getChoiceTypeActiveAll(){
            this.show = true;
            this.listOption = [];
            Api.getChoiceTypeActiveAll().then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.listOption = data.result
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },

        validatedForm(){
            this.validated         = true;
            var checkEmptyForm     = this.name;
            var checkEmptyQuestion = this.listQuestion.find(itQ => itQ.name.trim()=='');
            var checkEmptyChoice   = this.listQuestion.find(itQ => {
                return itQ.listChoice.find((itC,idC) => {
                    return (itC.name.trim()=='' || itC.class!='');
                });
            });

            if(checkEmptyForm.trim()!='' && checkEmptyQuestion==undefined && checkEmptyChoice==undefined){
                this.saveForm();
            }else{
                this.$swal('กรุณากรอกข้อมูล!', '', "warning");
            }
        },

        saveForm(){
            this.show = true;
            var token = this.user.token;
            var body = {
                name: this.name,
                description: this.description,
                listQuestion: this.listQuestion.map((it,id) => {
                    Vue.set(it, 'request', Number(it.request));
                    Vue.set(it, 'choiceTypeId', it.type.id);
                    return it;
                })
            };
            Api.saveForm(token,body).then(res => {
                this.show = false;
                var {data} = res;
                if(data.result){
                    this.$swal(data.message, '', "success");
                    this.$router.push({name: 'manageform'});
                }else{
                    this.$swal(data.message, '', "warning");
                }
            }).catch(err => {
                this.show = false;
                this.$swal('เกิดข้อผิดพลาด!', 'เกิดข้อผิดพลาดจากเซิร์ฟเวอร์', "error");
            })
        },

        choose(){
            this.cursor = true;
        },

        unchoose(){
            this.cursor = false;
        },

        onFocus(event) {
            event.target.select();
        },

    }
}
</script>

<style scoped>
    .border-header {
        border-top: 10px solid rgb(103 58 183) !important;
    }

    .border-active {
        border-left: 6px solid #4285f4 !important;
    }

    .textarea-description {
        line-height: 1 !important;
    }

    .iconxx{
        font-size: 25px !important;
        vertical-align: middle !important;
    }

    .color-secondary{
        color: #9d9d9d;
    }

    .div-footer{
        position: sticky;
        top: 56px;
        z-index: 999;
    }

</style>